import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DaLinkModule } from '../da-link';
import { EventsModule } from '../events';
import { TabSectionComponent } from './tab-section.component';
import { TabComponent } from './tab/tab.component';
import { TabsComponent } from './tabs/tabs.component';

@NgModule({
    declarations: [TabSectionComponent, TabsComponent, TabComponent],
    imports: [CommonModule, DaLinkModule, FormsModule, EventsModule, TranslateModule.forChild()],
    exports: [TabSectionComponent],
    providers: []
})
export class TabSectionModule {
    constructor() {}
}
